import ProductSales from './CategorySales';

export default ProductSales;
